module.exports = __webpack_public_path__ + "img/MultiLineText.0596c56b.svg";